import { MapPin } from "lucide-react";

const ORIGIN = { x: 55, y: 66 }; // Texarkana, northeast Texas

// ~70 destination points spread across every region of the continental US.
const CITIES = [
  { x: 7, y: 40 }, { x: 8, y: 48 }, { x: 9, y: 55 }, { x: 10, y: 62 }, { x: 11, y: 35 },
  { x: 9, y: 68 }, { x: 12, y: 20 }, { x: 15, y: 15 }, { x: 10, y: 28 }, { x: 18, y: 70 },
  { x: 22, y: 66 }, { x: 16, y: 60 }, { x: 24, y: 72 }, { x: 20, y: 58 }, { x: 26, y: 45 },
  { x: 30, y: 38 }, { x: 28, y: 55 }, { x: 32, y: 50 }, { x: 34, y: 60 }, { x: 29, y: 30 },
  { x: 46, y: 78 }, { x: 50, y: 82 }, { x: 52, y: 74 }, { x: 48, y: 70 }, { x: 44, y: 85 },
  { x: 44, y: 55 }, { x: 48, y: 48 }, { x: 52, y: 58 }, { x: 46, y: 42 }, { x: 50, y: 40 },
  { x: 54, y: 50 }, { x: 58, y: 40 }, { x: 62, y: 45 }, { x: 60, y: 52 }, { x: 64, y: 38 },
  { x: 66, y: 48 }, { x: 59, y: 33 }, { x: 63, y: 30 }, { x: 66, y: 30 }, { x: 70, y: 32 },
  { x: 68, y: 38 }, { x: 72, y: 28 }, { x: 58, y: 72 }, { x: 62, y: 68 }, { x: 64, y: 76 },
  { x: 66, y: 70 }, { x: 60, y: 80 }, { x: 68, y: 82 }, { x: 56, y: 78 }, { x: 70, y: 72 },
  { x: 74, y: 68 }, { x: 72, y: 78 }, { x: 76, y: 74 }, { x: 78, y: 80 }, { x: 80, y: 88 },
  { x: 82, y: 92 }, { x: 79, y: 84 }, { x: 82, y: 38 }, { x: 85, y: 34 }, { x: 88, y: 32 },
  { x: 90, y: 30 }, { x: 84, y: 42 }, { x: 87, y: 40 }, { x: 91, y: 36 }, { x: 83, y: 46 },
  { x: 86, y: 28 }, { x: 80, y: 48 }, { x: 78, y: 52 }, { x: 82, y: 50 }, { x: 76, y: 55 },
];

export default function ShipMap() {
  return (
    <div data-testid="ship-map" className="relative w-full bg-black">
      <div className="relative w-full">
        <img
          src="/us-map.png"
          alt="Map of the United States showing shipping routes from Texarkana, Texas to cities nationwide"
          className="w-full h-auto block select-none"
          draggable={false}
        />

        {/* Animated flowing lines */}
        <svg className="absolute inset-0 w-full h-full pointer-events-none" viewBox="0 0 100 100" preserveAspectRatio="none">
          {CITIES.map((c, i) => (
            <line
              key={i}
              x1={ORIGIN.x}
              y1={ORIGIN.y}
              x2={c.x}
              y2={c.y}
              stroke="#D4AF37"
              strokeWidth="0.16"
              strokeLinecap="round"
              className="ship-line"
              style={{ animationDelay: `${(i % 12) * 0.28}s`, opacity: 0.75 }}
            />
          ))}
        </svg>

        {/* Pulsing destination dots */}
        {CITIES.map((c, i) => (
          <span
            key={i}
            className="ship-dot absolute w-1.5 h-1.5 rounded-full bg-copper pointer-events-none"
            style={{ left: `${c.x}%`, top: `${c.y}%`, animationDelay: `${(i % 8) * 0.4}s` }}
          />
        ))}

        {/* Origin marker — Texarkana */}
        <span className="absolute -translate-x-1/2 -translate-y-1/2 z-10" style={{ left: `${ORIGIN.x}%`, top: `${ORIGIN.y}%` }}>
          <span className="relative flex h-4 w-4">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-copper opacity-70" />
            <span className="relative inline-flex rounded-full h-4 w-4 bg-copper border-2 border-white/80 shadow-[0_0_12px_4px_rgba(212,175,55,0.6)]" />
          </span>
        </span>
        <div
          className="absolute -translate-x-1/2 z-10 flex items-center gap-1.5 bg-black/70 backdrop-blur border border-copper/50 px-2.5 py-1"
          style={{ left: `${ORIGIN.x}%`, top: `calc(${ORIGIN.y}% + 14px)` }}
        >
          <MapPin size={12} className="text-copper" />
          <span className="text-[10px] uppercase tracking-[0.2em] text-sand whitespace-nowrap">Texarkana, TX</span>
        </div>
      </div>
    </div>
  );
}
